export default __webpack_public_path__ + "static/draugystes-pagrindinis-f4f2cccd56fd96d09325878342c5faa4.png";